export default "__VITE_PUBLIC_ASSET__3db66f8c__"